var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeading", {
        attrs: { text: "Категории страниц помощи" },
        scopedSlots: _vm._u(
          [
            {
              key: `toolbar.prepend`,
              fn: function () {
                return [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2 mt-2",
                      attrs: {
                        link: "",
                        small: "",
                        outlined: "",
                        color: "primary",
                        disabled: _vm.isMutationLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.newCategoryHandler()
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { small: "" } },
                        [_vm._v(" mdi-plus ")]
                      ),
                      _vm._v(" Создать категорию "),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "v-row",
        [
          _vm.loadingData
            ? _c(
                "v-col",
                { staticClass: "wrapper" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ],
                1
              )
            : _c(
                "v-col",
                [
                  _c(
                    "PageContent",
                    [
                      _c("TreeInfoCategories", {
                        attrs: {
                          data: _vm.infoCategories,
                          loading: _vm.loadingData,
                        },
                        on: {
                          "new-category-children": function ($event) {
                            return _vm.newCategoryHandler($event)
                          },
                          "remove-category": function ($event) {
                            return _vm.deleteInfoCategory($event)
                          },
                          "edit-category": function ($event) {
                            return _vm.editCategoryHandler($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _vm.infoCategory
        ? _c("FormDialog", {
            attrs: {
              data: _vm.infoCategory,
              id: _vm.parentCategoryId,
              "info-categories": _vm.infoCategories,
              language: _vm.language,
              loading: _vm.loadingData,
              disabled: _vm.isMutationLoading,
            },
            on: {
              submit: _vm.btnFormClick,
              close: _vm.formDialogCloseHandler,
              "language-update": function ($event) {
                _vm.language = $event
              },
            },
          })
        : _vm._e(),
      _c("ConfirmationDialog", {
        ref: "confirmInfoCategoryRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }